import { combineReducers } from 'redux';
import userDealerMappedReducer from './dealer-settings/reducer/userDealerMappedReducer';

export const userSettingsCombineReducer = () => combineReducers({
    dealerSettings: userDealerMappedReducer,

});
